<template>
  <section
    style="background-color: #1d2b58; width: 800px; margin: 0 auto"
    class="my-15 py-5 qt"
  >
    <v-row class="container">
      <v-col cols="12">
        <!-- <contactList /> -->
        <v-row>
          <v-col
            cols="7"
            class="pl-15"
            style="background-color: #1d2b58; color: white"
          >
            <img src="/img/Picture.png" />
          </v-col>

          <v-col class="text-center" cols="5" style="color: white">
            <p style="font-size: 50px; margin: 0">
              {{ $props.name.toUpperCase() }}
            </p>
            <div style="width: 100%; border-top: solid 2px #fff">
              <h3 class="pt-2 text-center">No: #{{ $props.item.id }}</h3>
            </div>
            <div style="width: 100%">
              <h3 class="pt-1 text-center">
                Ref Number: #{{ $props.item.ref_no }}
              </h3>
            </div>
            <!-- <div>
                <div class="d-flex justify-end">
                  <h4 class="mr-15">Invoice#</h4>
                  <h4>52148</h4>
                </div>

                <div class="d-flex justify-end">
                  
                </div>
               </div> -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="px-15">
      <v-container style="background: white">
        <v-row class="d-flex justify-space-between px-10 py-5">
          <div class="primary-color">
            <h3>
              {{ $props.name.charAt(0).toUpperCase() + $props.name.slice(1) }}
              to:
            </h3>
            <h4 class="">{{ $props.item.customer.full_name }}</h4>
            <h4>
              {{ $props.item.customer.address }},
              {{ $props.item.customer.city }}, {{ $props.item.customer.state }},
              {{ $props.item.customer.country }}
            </h4>
          </div>

          <div class="primary-color">
            <h3 class="mr-15">
              {{ $props.name.charAt(0).toUpperCase() + $props.name.slice(1) }}
              Date:
            </h3>
            <h4>{{ changeDateFormat($props.item.issue_date) }}</h4>
          </div>
        </v-row>
      </v-container>
    </v-row>

    <v-row class="px-15 mt-5">
      <v-col cols="12">
        <v-row style="background: #faf7f7">
          <v-container>
            <table style="width: 100%">
              <tr>
                <th>SL.</th>
                <th>Item Description</th>
                <th>Price</th>
                <th>Qty.</th>
                <th>Total</th>
              </tr>
              <tr v-for="(p, i) in $props.item.products" :key="p.id">
                <td v-if="approval">
                  <v-checkbox
                    v-bind="basic"
                    v-model="form.products"
                    :value="p.product_id"
                  >
                  </v-checkbox>
                </td>
                <td v-else>{{ i + 1 }}</td>
                <td>{{ p.description }}</td>
                <td>${{ p.price }}</td>
                <td>{{ p.quantity }}</td>
                <td>${{ p.price * p.quantity }}</td>
              </tr>
            </table>
          </v-container>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-2 px-15">
      <v-col cols="12" style="background: white">
        <v-container>
          <v-row>
            <!-- <v-col cols="1"></v-col> -->

            <v-col cols="6">
              <div class="pt-4" v-if="$props.name === 'invoice'">
                <h2 class="px-2" style="background: rgba(0, 255, 242, 0.1)">
                  Payment Details:
                </h2>
                <div class="d-flex justify-space-between mt-3">
                  <h4 class="mr-15 py-2">Account #:</h4>
                  <h4>1234 5678 9012</h4>
                </div>
                <div class="d-flex justify-space-between">
                  <h4 class="mr-15 py-2">Account Name:</h4>
                  <h4>Lorem Ipsum</h4>
                </div>
                <div class="d-flex justify-space-between">
                  <h4 class="mr-15 py-2">Bank Details:</h4>
                  <h4>Your Details</h4>
                </div>
              </div>
            </v-col>

            <v-col cols="1"></v-col>

            <v-col cols="5">
              <div class="d-flex justify-space-between">
                <h4 class="mr-15 py-2">Sub total:</h4>
                <h4>${{ subTotal }}</h4>
              </div>
              <div
                class="d-flex justify-space-between"
                v-for="t in $props.item.tax"
                :key="t.id"
              >
                <h4 class="mr-15 py-2">{{ getName(t) }}:</h4>
                <h4>${{ getTaxAmount(t) }}</h4>
              </div>
              <div class="d-flex justify-space-between">
                <h4 class="mr-15 py-2">Total Tax:</h4>
                <h4>${{ taxTotal }}</h4>
              </div>
              <div class="d-flex justify-space-between">
                <h4 class="mr-15 py-2">Discount:</h4>
                <h4>${{ $props.item.discount }}</h4>
              </div>

              <v-divider style="border-bottom: 2px solid"></v-divider>
              <div class="d-flex justify-space-between pb-15">
                <h3 class="mr-15 py-2">Total:</h3>
                <h3>${{ grandTotal }}</h3>
              </div>

              <div class="d-flex justify-end mt-15 ml-auto" style="width: 50%">
                <v-divider style="border-bottom: 2px solid"> </v-divider>
              </div>
              <h3 class="text-right">Authorized Signature</h3>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <h4 class="px-15 mt-5" style="color: white">Thank You For Your Business</h4>
    <v-row v-if="approval">
      <v-col class="d-flex justify-center">
        <v-btn color="primary" elevation="2" v-on:click="submit">
          Approve
        </v-btn>
        <v-btn class="ml-4" color="primary" elevation="2" @click="print">
          Print
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="otpDialog" max-width="450px">
      <otp :quotation="$props.item" @otpVerified="otpVerified" />
    </v-dialog>
  </section>
</template>
<script>
import util from "@/util/util";
import otp from "@/components/Quotation/otp-screen";
export default {
  components: { otp },
  props: {
    item: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      taxs: [],
      basic: util.input.basic,
      approval: false,
      otpDialog: false,
      form: {
        products: [],
      },
    };
  },
  mounted() {
    this.getTaxes();
    if (
      this.$route.params.approve &&
      this.$route.params.approve == "approval"
    ) {
      this.approval = true;
    }
  },
  methods: {
    print() {
      window.print();
    },
    getTaxes() {
      util
        .http({
          url: "tax/public",
          method: "get",
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.taxs = res.data.data;
          } else {
            util.notify(0, res.data.errors[0]);
          }
        });
    },
    getName(tax) {
      let a = this.taxs.find((t) => t.id == tax.id);
      if (a) {
        return a.name;
      }
    },
    getTaxAmount(tax) {
      let a = this.taxs.find((t) => t.id == tax.id);
      if (a) {
        return (this.subTotal * a.percentage) / 100;
      }
    },
    changeDateFormat(date) {
      return util.changeDateFormat(date);
    },
    submit() {
      this.otpDialog = true;
    },
    otpVerified() {
      this.otpDialog = false;
      util
        .http({
          url: "/quotation/public/approve/" + this.$props.item.id,
          method: "post",
          data: this.form,
        })
        .then((resp) => {
          if (resp.data.status == 1) {
            util.notify(1, "Approved");
          } else {
            util.notify(0, resp.data.errors[0]);
          }
        });
    },
  },
  computed: {
    subTotal() {
      let total = 0;
      this.$props.item.products.forEach((item) => {
        total += item.quantity * item.price;
      });
      return total;
    },
    taxTotal() {
      let total = 0;
      this.$props.item.tax.forEach((tax) => {
        total += this.getTaxAmount(tax);
      });
      return total;
    },
    grandTotal() {
      return this.subTotal - this.$props.item.discount + this.taxTotal;
    },
  },
};
</script>

<style scoped>
.v-dialog div {
  background: #fff;
}
@media print {
  .print {
    display: none;
  }
}
</style>
